<template>
  <div class="d-flex flex-column flex-grow-1 h-full">
  <div class="">
    <swiper
        ref="mySwiper"
        :options="swiperOption"
        class="gallery-top position-relative"
        @slideChange="changeSwiperIndex"
    >
      <swiper-slide
          v-for="(links, k) in linkUrl"
          :key="k"
          class="html-slide"
      >
        <iframe
            :src="links"
            frameborder="0"
            scrolling="0"
            title="description"
            height="50%"
            width="100%"
        ></iframe>
      </swiper-slide>
    </swiper>
<!--    <div class="swiper-pagination"></div>-->
  </div>
  </div>
</template>

<script>
import {swiper, swiperSlide} from "vue-awesome-swiper";
import htmlvideo from "@/json/htmlvideo.json";
import learnApi from "@/api/learnApi";

export default {
  name: "InteractiveHtmlType",

  props: ['lessonData'],

  components: {
    swiper,
    swiperSlide,
  },

  watch: {
    setSlideNumber() {
      this.mySwiper.slideTo(this.setSlideNumber - 1);
    },
  },

  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  data() {
    return {
      linkUrl: this.lessonData.html.files.filter((url) => !url.includes("__MACOSX")),
      myJson: htmlvideo,
      swiperOption: {
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "fraction",
        },
      },
      slideSwiper: null,
      progressBar: 0,
    }
  },

  mounted() {
    this.updateProgress();
  },

  methods: {
    // 진도저장 API 호출(update progress)
    updateProgress() {
      let params = this.setParams();
      let responseData = null;

      let progressBarLength = Math.floor(params.current*100/params.total)
      if(parseInt(progressBarLength)){
        this.progressBar = progressBarLength;
      } else {
        this.progressBar = 0;
      }

      if (!this.rate) {
        learnApi
            .learnLessonProgression(params)
            .then((response) => {
              responseData = response.data.data;
              this.rate = responseData.rate;
              this.last = responseData.last;
              this.$emit('updateProgress', this.rate);
            })
            .catch((err) => {});
      }
    },

    setParams() {
      let params = {
        total: this.lessonData.html.count,
        //current: this.currentSliderIndex,
        current: 1,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };
      return params;
    },

    changeSwiperIndex() {
      this.currentSliderIndex = this.$refs.mySwiper.swiper.realIndex;
      if (this.countFile === parseInt(this.currentSliderIndex + 1)) {
        this.addOpacityClass = true
      } else {
        this.addOpacityClass = false
      }

      let params = {
        total: this.countFile,
        current: this.currentSliderIndex + 1,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };

      let progressBarLength;
      progressBarLength = Math.floor(params.current * 100 / params.total);

      if (parseInt(progressBarLength)) {
        this.progressBar = progressBarLength;
      } else {
        this.progressBar = 0;
      }

      learnApi.learnLessonProgression(params)
          .then((response) => {
            let responseData = response.data.data;
            this.rate = responseData.rate;
            this.last = responseData.last;
          })
          .catch((err) => {});
    },
  }
}
</script>

<style scoped>

</style>
